import axios from 'axios';
import {
  AuditQuery, EventsQuery, ExceptionInput, ExceptionPatch, NetworkItem, Paged, RuleAuditRow, RuleEvent, RuleRecord, RulesOverview,
  SimulateInput, SimulateResponse
} from './rulesTypes';

/** Правила документов: с портала запросы идут через основной бэкенд (/api/v2/documents/rules → :3003) */
const BASE = '/api/v2/documents/rules';

/** Пустые значения фильтров не отправляем */
const clean = <T extends object>(q: T): Record<string, string> => Object.fromEntries(
  Object.entries(q).filter(([, v]) => v !== undefined && v !== null && v !== '').map(([k, v]) => [k, String(v)])
);

export const rulesApi = {
  async overview(signal?: AbortSignal): Promise<RulesOverview> {
    const res = await axios.get(`${BASE}/`, { signal });
    return res.data;
  },

  async saveNetwork(items: NetworkItem[]): Promise<{ success: boolean; records: RuleRecord[] }> {
    const res = await axios.put(`${BASE}/network`, { items });
    return res.data;
  },

  async createException(input: ExceptionInput): Promise<{ success: boolean; records: RuleRecord[]; created: number; updated: number }> {
    const res = await axios.post(`${BASE}/exceptions`, input);
    return res.data;
  },

  async updateException(id: number, patch: ExceptionPatch): Promise<{ success: boolean; record: RuleRecord }> {
    const res = await axios.put(`${BASE}/exceptions/${id}`, patch);
    return res.data;
  },

  async remove(id: number): Promise<{ success: boolean }> {
    const res = await axios.delete(`${BASE}/${id}`);
    return res.data;
  },

  async events(q: EventsQuery, signal?: AbortSignal): Promise<{ success: boolean; rows: RuleEvent[]; pagination: Paged }> {
    const res = await axios.get(`${BASE}/events`, { params: clean(q), signal });
    return res.data;
  },

  async audit(q: AuditQuery, signal?: AbortSignal): Promise<{ success: boolean; rows: RuleAuditRow[]; pagination: Paged }> {
    const res = await axios.get(`${BASE}/audit`, { params: clean(q), signal });
    return res.data;
  },

  async simulate(input: SimulateInput): Promise<SimulateResponse> {
    const res = await axios.post(`${BASE}/simulate`, input);
    return res.data;
  }
};
